import {
	errorHandler,
	deviceDetect,
	modalsSlice,
	notifyMessageCreator,
	loadersSlice,
} from 'Modules'
import { get } from 'lodash'
import { call, delay, put, select, takeLatest } from 'typed-redux-saga'
import { FormNames } from 'Src/constants/FormNames'
import {
	reserveAccountApi,
	OrderStepType,
	ReserveAccountModel,
	reserveAccountNS,
	reserveAccountSlice,
	ordersSlice,
} from 'Pages/orders_design'
import { MODAL_NAME } from 'Src/constants/ModalName'
import { FrontUrls } from 'Constants/FrontUrls'
import { routerActions } from 'connected-react-router'
import { Deserialize } from 'cerialize'
import { NewOrderModal } from 'Pages/orders_design/components/desktop_orders/modals/NewOrderModal'
import { takeEveryUnique } from 'Helpers'

export function* createReserveAccount(action: reserveAccountNS.createReserveAccount) {
	const isMobile = yield* select(deviceDetect.getIsMobile)
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { id, data } = action.payload
		const res = yield* call(reserveAccountApi.createReserveAccount, id, data)
		yield* put(ordersSlice.actions.setReserveAccountInOrder(res))
		yield* put(ordersSlice.actions.setStep(OrderStepType.WAITING_RESERVE))
		if (!isMobile) {
			yield* put(routerActions.push(FrontUrls.orders_redesign.index))
			yield* put(
				modalsSlice.actions.showModal({
					Component: NewOrderModal,
					key: MODAL_NAME.ORDER_CREATE,
					componentProps: { orderId: id, isDraft: true },
					width: '480px',
				})
			)
		} else {
			yield* put(routerActions.push(FrontUrls.orders_redesign_mobile.created))
		}
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		if (isMobile) {
			yield* call(errorHandler, error, FormNames.ORDERS.MOBILE.RESERVE)
		} else {
			yield* call(errorHandler, error, FormNames.ORDERS.EDIT_ORDER)
		}
	}
}

export function* showModalAfterOutOfficeAppointment(
	action: reserveAccountNS.showModalAfterOutOfficeAppointment
) {
	const isMobile = yield* select(deviceDetect.getIsMobile)
	const { id } = action.payload
	yield* put(ordersSlice.actions.setStep(OrderStepType.WAITING_RESERVE))
	if (!isMobile) {
		yield* put(routerActions.push(FrontUrls.orders_redesign.index))
		yield* delay(100)
		yield* put(
			modalsSlice.actions.showModal({
				Component: NewOrderModal,
				key: MODAL_NAME.ORDER_CREATE,
				componentProps: { orderId: id, isDraft: true },
				width: '480px',
			})
		)
	} else {
		yield* put(routerActions.push(FrontUrls.orders_redesign_mobile.created))
	}
}
export function* checkReserveAccountPossibility(
	action: reserveAccountNS.checkReserveAccountPossibility
) {
	try {
		const { inn, product_ids } = action.payload
		yield* call(reserveAccountApi.checkReserveAccountPossibility, inn, product_ids)
		yield* put(
			reserveAccountSlice.actions.setReserveAccountOptions({ newOptions: { locked: false } })
		)
	} catch (error) {
		if (get(error, 'data.errors[0].possibility_to_reserve_an_account')) {
			yield* call(notifyMessageCreator, 'orders.reserve_account.unavailable')
			yield* put(
				reserveAccountSlice.actions.setReserveAccountOptions({ newOptions: { locked: true } })
			)
		} else {
			yield* call(errorHandler, error)
		}
	}
}

export function* sendOrderWithoutReserveAccount(
	action: reserveAccountNS.sendOrderWithoutReserveAccount
) {
	try {
		const isMobile = yield* select(deviceDetect.getIsMobile)
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { id, reloadOrder } = action.payload
		yield* call(reserveAccountApi.sendOrderWithoutReserveAccount, id)
		if (!isMobile) {
			if (reloadOrder) {
				yield* put(ordersSlice.actions.getOrder({ id, updateList: true }))
			} else {
				yield* put(routerActions.push(FrontUrls.orders_redesign.index))
				yield* put(
					modalsSlice.actions.showModal({
						Component: NewOrderModal,
						key: MODAL_NAME.ORDER_CREATE,
						componentProps: { orderId: id, isDraft: false },
						width: '480px',
					})
				)
			}
		} else {
			yield* put(routerActions.push(FrontUrls.orders_redesign.index))
		}
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

export function* updateReserveAccountInOrder(action: reserveAccountNS.updateReserveAccountInOrder) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(reserveAccountApi.getReserveAccountInOrder, action.payload)
		const reserveAccount = Deserialize(res, ReserveAccountModel)
		yield* put(ordersSlice.actions.setReserveAccountInOrder(reserveAccount))
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

export function* reserveAccountSaga() {
	yield* takeEveryUnique(
		reserveAccountSlice.actions.createReserveAccount.type,
		createReserveAccount
	)
	yield* takeLatest(
		reserveAccountSlice.actions.checkReserveAccountPossibility.type,
		checkReserveAccountPossibility
	)
	yield* takeEveryUnique(
		reserveAccountSlice.actions.sendOrderWithoutReserveAccount.type,
		sendOrderWithoutReserveAccount
	)
	yield* takeLatest(
		reserveAccountSlice.actions.updateReserveAccountInOrder.type,
		updateReserveAccountInOrder
	)
	yield* takeLatest(
		reserveAccountSlice.actions.showModalAfterOutOfficeAppointment.type,
		showModalAfterOutOfficeAppointment
	)
}
